// ============================================================
// Full path:
//   D:\Thyroid Consultation Software\ThyroConsult Frontend\thyroconsult-frontend\src\content\publicDoctors.js
//
// Doctors shown on the public "Our Doctors" page (/our-doctors) and linked
// from the home-page footer (1 Oct 2026 — PayU asked for doctor
// information on the website). While this list is empty, the page and its
// link are hidden.
//
// List only doctors who have agreed in writing to be shown publicly, and
// whose registration has been checked on the NMC / state council register.
// Leave out any line you don't have (it is then not shown).
//
// Example:
//   {
//     name: 'Dr. Full Name',
//     qualifications: 'MBBS, MD (Medicine), DM (Endocrinology)',
//     specialisation: 'Endocrinology',
//     registration: 'Maharashtra Medical Council, Reg. No. 123456',
//     experience: '12 years',
//     about: 'One or two sentences about the doctor.',
//   },
// ============================================================

export const PUBLIC_DOCTORS = [
  {
    name: 'Dr. Hasmukhkumar Mangilal Jain',
    qualifications: 'MBBS, DRM',
    specialisation: 'Nuclear Medicine',
    registration: 'Maharashtra Medical Council, Reg. No. 85738',
    experience: '20 years',
    about: 'Experienced nuclear medicine physician with a special interest in thyroid disorders and thyroid cancer.',
  },
];
